<template>
<svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.61346 7.73389L20.3867 7.73389" stroke="#773DBD" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.1367 2.48389L20.3867 7.73389L15.1367 12.9839" stroke="#773DBD" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
